<template>
  <div class="ecommerce_product_select_category" v-if="categorylist">
    <div style="overflow-x: auto; white-space: nowrap; padding-bottom: 15px">
      <v-btn
        small
        depressed
        :outline="currentCategory != category.id"
        :color="currentCategory != category.id ? 'grey' : 'primary'"
        v-for="(category, index) in categorylist"
        @click="onChangeCategory(category.id)"
        :key="'category_' + index"
        class="ma-1"
        >{{ category.name }}</v-btn
      >
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  props: ['value', 'selected'],
  data: function () {
    return {
      categorylist: this.value,
      currentCategory: null
    }
  },
  mounted: function () {
    // console.log(this.selected)

    if (this.selected == null || !Number.isInteger(this.selected)) {
      if (this.categorylist && this.categorylist[0]) {
        this.currentCategory = this.categorylist[0].id
      }
    } else {
      this.currentCategory = this.selected
    }
    this.$emit('onChangeCategory', this.currentCategory)
  },
  methods: {
    onChangeCategory: function (index) {
      let vm = this
      vm.currentCategory = index
      // console.log(vm.currentCategory)
      vm.$emit('onChangeCategory', vm.currentCategory)
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      let vm = this
      vm.categorylist = newVal

      if (this.selected == null || !Number.isInteger(this.selected)) {
        if (this.categorylist && this.categorylist[0]) {
          this.currentCategory = this.categorylist[0].id
        }
      } else {
        this.currentCategory = this.selected
      }
    },
    selected: function (newVal, oldVal) {
      if (newVal == null || !Number.isInteger(this.selected)) {
        this.currentCategory = this.categorylist[0].id
        this.$emit('onChangeCategory', this.currentCategory)
      } else {
        this.currentCategory = newVal
        this.$emit('onChangeCategory', this.currentCategory)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ananda/SelectCategory.vue